import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientCompQuantityCostPage } from "../ingredient-comp-quantity-cost/ingredient-comp-quantity-cost";
import { IngredientsServices } from "../../services";
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { StockListPage } from '../../../stock/stock-list/stock-list';

/**
 * Generated class for the IngredientCompCreateSelectIngPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-comp-create-select-ing',
  templateUrl: 'ingredient-comp-create-select-ing.html',
})
export class IngredientCompCreateSelectIngPage {

  update_state: boolean = false;
  //dish_uid: string;
  ingredient_uid: string;
  ingredients: any;
  ingredient_measurement: any;
  ingredient_name: any;
  selected_collapse: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientsServices: IngredientsServices,
    public toastCtrl: ToastController,
    public globals: Globals,
    public translate: TranslateService,
    private alertCtrl: AlertController,) {


    this.update_state = this.navParams.get('update_state');
    this.ingredient_uid = this.navParams.get('ingredient_uid');
    this.ingredients = this.navParams.get('ingredients');
    this.ingredient_measurement = this.navParams.get('ingredient_measurement');
    this.ingredient_name = this.navParams.get('ingredient_name');
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.ingredientsServices.show_alert_delete && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.ingredientsServices.quick_create = false;
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.ingredientsServices.afs.collection('ingredients').doc(this.ingredient_uid).delete();
                resolve();
                this.navCtrl.setRoot(StockListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  openIngredientCompQuantCost() {
    this.ingredientsServices.show_alert_delete = false;
    if (this.ingredientsServices.ingredients_array_tmp.length > 0) {

      if (this.update_state) {
        this.globals.GAtrackView('Ingredients', 'Ingredients - Select ings - Update', this.globals.restaurant.email, 'Create/Update', 'Update select ings', 'Ingredients', this.ingredient_name);
      } else {
        this.globals.GAtrackView('Ingredients', 'Ingredients - Select ings - Create', this.globals.restaurant.email, 'Create/Update', 'Create select ings', 'Ingredients', this.ingredient_name);
      }

      this.navCtrl.push(IngredientCompQuantityCostPage, {
        ingredient_measurement: this.ingredient_measurement,
        ingredients: this.ingredients,
        ingredient_uid: this.ingredient_uid,
        ingredient_name: this.ingredient_name,
        update_state: this.update_state,
        real_weight: this.ingredients.real_weight
      });


    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-selecciona-ingrediente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }
  async ionViewWillEnter() {
    this.ingredientsServices.getPagesIngredients('all', 0);
    this.ingredientsServices.page_active = 1;

    if (this.update_state) {
      if (this.ingredients != null) {
        if (Object.keys(this.ingredients).length > 0) {

          this.ingredientsServices.ingredients_array_tmp = Array(); //Reiniciamos array para no tener los antiguos valores.

          for (let entry of this.ingredients.foodcost) {
            //Recuperamos los valores del providers a tratar
            await this.ingredientsServices.firestore.collection('ingredients').doc(entry.uid).get().then(doc => {
              var v = doc.data();
              var _array = Array();
              _array.push(entry.uid);
              _array.push(v.name);
              _array.push(v.measurement);
              _array.push(v.providers);
              _array.push(v.tax);

              if (v.sub_recipe) {
                _array.push(this.ingredientsServices.returnPricePerMeasurement(v.price_static, v.real_weight));
              } else {
                _array.push(v.price_static);
              }
              _array.push(v.provider_static);
              _array.push(v.tags);
              if (v.allergens == undefined) {
                v.allergens = [];
                _array.push(v.allergens);
              } else {
                _array.push(v.allergens);
              }
              //_array.push(v.allergens);
              _array.push(v.stock_alert);
              _array.push(v.stock);
              _array.push(v.sub_recipe);
              _array.push(entry.quantity);//cantidad
              _array.push(entry.quantity_gross);//cantidad bruta
              _array.push(entry.waste);//merma
              _array.push(entry.price_static);//preu final
              _array.push(this.ingredients.price_static);//total
              _array.push(entry);
              _array.push(this.ingredients.real_weight);
              _array.push(v.recipe);
              _array.push(v.time);
              _array.push(v.tools);
              _array.push(v.image);
              _array.push(entry.ingredient_include_subrecipe);
              this.ingredientsServices.ingredients_array_tmp.push(_array);
            });
          }
        }
      }
    } else {
      this.ingredients = Array();
      this.ingredientsServices.ingredients_array_tmp = Array();
    }
    this.ingredientsServices.ingredients_array_tmp = [...this.ingredientsServices.ingredients_array_tmp];
  }
  searchIngredientNode(value, type) {
    this.ingredientsServices.searchIngredientNode(value, type);
  }
  collapse() {
    this.selected_collapse = !this.selected_collapse;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-create-select-ing.ts